<template>
  <el-dialog
    :modelValue="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    class="new_dialog"
    width="597px"
    title="发布客户端"
  >
    <div class="flex">
      <div class="t1">发布客户端下载和使用说明</div>
      <div class="t2">
        飞书链接：
        <el-link
          href="https://eirdkdsihn.feishu.cn/wiki/wikcnQLxfT75kxt87yApkbYThbb"
          target="_blank"
        >
          https://eirdkdsihn.feishu.cn/wiki/wikcnQLxfT75kxt87yApkbYThbb
        </el-link>
      </div>
      <div class="t3">
        密码：0F7b
        <el-link type="primary" :underline="false" @click="copy_handle">
          复制
        </el-link>
      </div>
      <el-button type="primary" @click="emit('update:modelValue', false)">
        知道了
      </el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { toRefs } from 'vue'
import { copyText } from 'vue3-clipboard'
import { ElMessage } from 'element-plus'

const props = defineProps({
  modelValue: { type: Boolean },
})
const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const copy_handle = (event) => {
  copyText('0F7b', undefined, (error, event) => {
    if (error) {
      ElMessage.error('复制失败')
    } else {
      ElMessage.success('复制成功')
    }
  })
}
</script>

<style lang="scss" scoped>
.flex {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .t1 {
    margin-bottom: 15px;
    font-size: 24px;
    font-weight: bold;
  }
  .t2 {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
  }
  .t3 {
    margin-bottom: 57px;
    height: 55px;
    background: #0b1830;
    border-radius: 7px;
    border: 1px solid #354d7c;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 50px;
    .el-link {
      margin-left: 16px;
    }
  }
  .el-button {
    width: 145px;
  }
}
</style>
